import api from "./api/axiosInstance";

const ALLOWED_TYPES = new Set([
  "marketplace_filter_applied",
  "marketplace_near_me_used",
  "marketplace_view_mode_changed",
  "marketplace_map_viewed",
  "marketplace_widget_impression",
  "marketplace_widget_click",
]);

export const trackMarketplaceEvent = (type, payload = {}, sourceId) => {
  if (!ALLOWED_TYPES.has(type)) return;
  api
    .post("/listings/analytics", { type, payload, sourceId })
    .catch(() => {});
};

export default trackMarketplaceEvent;
